import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faNewspaper,
  faBell as fadBell,
  faCircleQuestion as fadCircleQuestion,
  faCircleUser as fadCircleUser,
  faLifeRing as fadLifeRing,
  faFaceThinking as fadFaceThinking,
  faCars as fadCars,
  faScreenUsers as fadScreenUsers,
  faHotel as fadHotel,
  faPersonHiking as fadPersonHiking,
  faTicketPerforated as fadTicketPerforated,
  faPeopleArrows as fadPeopleArrows,
  faToggleLargeOn as fadToggleLargeOn,
  faToggleLargeOff as fadToggleLargeOff,
  faDiagramCells as fadDiagramCells,
} from '@fortawesome/pro-duotone-svg-icons'
import {
  faChartPieAlt,
  faStopwatch,
  faUserFriends,
  faExchange,
  faBell,
  faCalendarAlt,
  faCogs,
  faUserPlus,
  faUpload,
  faDownload,
  faSync,
  faTimes,
  faEnvelopeOpenText,
  faFolderOpen,
  faBoxArchive,
  faEnvelope,
  faSignIn,
  faAddressBook,
  faTrashAlt,
  faMars,
  faVenus,
  faGenderless,
  faCopy,
  faPenSquare,
  faLongArrowRight,
  faLongArrowLeft,
  faCog,
  faPlus,
  faExclamationCircle,
  faExclamationTriangle,
  faMinus,
  faShieldAlt,
  faBrowser,
  faPlusCircle,
  faEllipsisHAlt,
  faAngleDown as falAngleDown,
  faLink,
  faCheckCircle,
  faClone,
  faSearch as falSearch,
  faEdit as falEdit,
  faInfoCircle as falInfoCircle,
  faSpinner,
  faSpinnerThird,
  faRocketLaunch,
  faFilePdf,
  faMobileAlt,
  faPencil,
  faCode,
  faGear,
  faCheck as falCheck,
  faKeyboard,
  faFileEdit,
  faArrowAltFromBottom,
  faQrcode,
  faClock,
  faSortAmountAsc,
  faSortAmountDesc,
  faSortSizeDown,
  faSort as falSort,
  faSortUp as falSortUp,
  faSortDown as falSortDown,
  faTable as falTable,
  faSync as falSync,
  faGlobe,
  faUsers as falUsers,
  faUser as falUser,
  faLock,
  faAngleLeft,
  faFileSignature,
  faFilterList,
  faLineColumns,
  faTableColumns,
  faChartPie,
  faCalendarDays,
  faListTimeline,
  faEllipsisV as falEllipsisV,
  faExpandArrows,
  faCalendarCheck,
  faCalendarXmark,
  faCalendarPlus as falCalendarPlus,
  faUserPen,
  faAnglesLeft as falAnglesLeft,
  faAnglesRight as falAnglesRight,
  faFileInvoice as falFileInvoice,
  faXmark as falXmark,
  faCheckDouble as falCheckDouble,
  faBars as falBars,
  faFileExport,
  faArrowRightToBracket,
  faPersonWalkingArrowRight,
  faPiggyBank as falPiggyBank,
  faList as falList,
  faTrashCan as falTrashCan,
  faTrash as falTrash,
  faEnvelopeCircleCheck as falEnvelopeCircleCheck,
  faPaperPlane as falPaperPlane,
  faUserClock as falUserClock,
  faUserCheck as falUserCheck,
  faTriangleExclamation as falTriangleExclamation,
  faSquareXmark as falSquareXmark,
  faCircleCheck as falCircleCheck,
  faPrint as falPrint,
  faEye as falEye,
  faEyeSlash as falEyeSlash,
  faArrowLeft as falArrowLeft,
  faArrowUp as falArrowUp,
  faArrowDown as falArrowDown,
  faArrowTurnUp as falArrowTurnUp,
  faArrowRotateLeft as falArrowRotateLeft,
  faArrowRotateRight as falArrowRotateRight,
  faDesktop as falDesktop,
  faMobile as falMobile,
  faLanguage as falLanguage,
  faWifiSlash as falWifiSlash,
  faFileLines as falFileLines,
  faLayerGroup as falLayerGroup,
  faPalette as falPalette,
  faPhotoFilm as falPhotoFilm,
  faHeading,
  faParagraph,
  faImage,
  faHandPointer,
  faCirclePlay,
  faDistributeSpacingVertical,
  faHorizontalRule,
  faShapes,
  faSquareDashed,
  faRectangleWide,
  faAlignLeft as falAlignLeft,
  faAlignCenter as falAlignCenter,
  faAlignRight as falAlignRight,
  faObjectsAlignTop,
  faObjectsAlignCenterVertical,
  faObjectsAlignBottom,
  faArrowsUpDown,
  faHashtag,
  faPhone as falPhone,
  faLinkSlash as falLinkSlash,
  faGripDotsVertical,
  faBold as falBold,
  faItalic as falItalic,
  faUnderline as falUnderline,
  faStrikethrough as falStrikethrough,
  faListUl,
  faListOl,
  faCrosshairs,
  faHouse as falHouse,
  faClockRotateLeft as falClockRotateLeft,
  faMagnifyingGlass as falMagnifyingGlass,
  faChevronDown as falChevronDown,
  faHand as falHand,
  faArrowsUpDownLeftRight as falArrowsUpDownLeftRight,
  faDrawCircle as falDrawCircle,
  faLoveseat as falLoveseat,
  faShapes as falShapes,
  faArrowDownToLine as falArrowDownToLine,
  faUpRightAndDownLeftFromCenter as falUpRightAndDownLeftFromCenter,
  faDownLeftAndUpRightToCenter as falDownLeftAndUpRightToCenter,
  faExpand as falExpand,
  faCompress as falCompress,
  faMagnifyingGlassPlus as falMagnifyingGlassPlus,
  faMagnifyingGlassMinus as falMagnifyingGlassMinus,
  faRotate as falRotate,
  faRotateRight as falRotateRight,
  faFileImport as falFileImport,
  faSquare as falSquare,
  faCircle as falCircle,
  faEllipsis as falEllipsis,
  faChevronUp as falChevronUp,
} from '@fortawesome/pro-light-svg-icons'
import {
  faCheckSquare,
  faTable,
  faEllipsisV,
  faAngleDown,
  faUser,
  faEdit,
  faUsers,
  faExchangeAlt,
  faEllipsisH,
  faCheck as farCheck,
  faList,
  faCalendarPlus,
  faBriefcase,
  faEnvelope as farEnvelope,
  faMars as farMars,
  faVenus as farVenus,
  faGenderless as farGenderless,
  faPenToSquare,
  faBrowser as farBrowser,
  faCloudArrowUp,
  faCloudArrowDown,
  faPalette,
  faMobileNotch,
  faDesktop,
  faTablet,
  faMobile,
  faFileCirclePlus,
  faTrashCan,
  faPlus as farPlus,
  faExternalLink as farExternalLink,
  faUserMinus,
  faDeleteLeft,
  faRocket,
  faMagnifyingGlass,
  faPartyHorn as farPartyHorn,
  faXmark,
  faUserGroup,
  faArrowsRotate as farArrowsRotate,
  faArrowsRepeat,
  faCalendarDays as farCalendarDays,
  faMessagesQuestion as farMessagesQuestion,
  faPhone as farPhone,
  faEnvelopeOpen as farEnvelopeOpen,
  faBuilding as farBuilding,
  faPlanetRinged as farPlanetRinged,
  faKey as farKey,
  faBars as farBars,
  faAlignJustify as farAlignJustify,
  faFilterList as farFilterList,
  faArrowUpRightFromSquare as farArrowUpRightFromSquare,
  faFilePdf as farFilePdf,
  faIdBadge as farIdBadge,
  faFileCode as faFileCode,
  faLongArrowLeft as farLongArrowLeft,
  faCopy as farCopy,
  faCar as farCar,
  faTrashCan as farTrashCan,
  faLink as farLink,
  faUnlink as farUnlink,
  faArrowLeft as faArrowLeft,
  faArrowProgress,
  faArrowsLeftRight as farArrowsLeftRight,
  faSidebar as farSidebar,
  faSidebarFlip as farSidebarFlip,
  faXmark as farXmark,
  faCalendarXmark as farCalendarXmark,
  faEnvelopeCircleCheck as farEnvelopeCircleCheck,
  faPaperPlane as farPaperPlane,
  faUserClock as farUserClock,
  faUserCheck as farUserCheck,
  faTriangleExclamation as farTriangleExclamation,
  faCircleCheck as farCircleCheck,
  faCartShopping as farCartShopping,
  faChevronLeft as farChevronLeft,
  faChevronDown as farChevronDown,
  faArrowDownToBracket as farArrowDownToBracket,
  faCalendar as farCalendar,
  faMinus as farMinus,
  faChevronUp as farChevronUp,
  faCircleXmark as farCircleXmark,
  faTrash as farTrash,
  faClock as farClock,
  faClockRotateLeft as farClockRotateLeft,
  faTicket as farTicket,
  faLinkSlash as farLinkSlash,
  faSparkles as farSparkles,
  faClipboardList as farClipboardList,
  faArrowRight as farArrowRight,
  faTicketPerforated as farTicketPerforated,
  faBagShopping as farBagShopping,
  faGlobe as farGlobe,
  faFileInvoiceDollar as farFileInvoiceDollar,
  faInfoCircle as farInfoCircle,
  faCreditCard as farCreditCard,
  faCreditCardBlank as farCreditCardBlank,
  faFileLines as farFileLines,
  faScaleBalanced as farScaleBalanced,
  faCog as farCog,
  faTicketsSimple as farTicketsSimple,
  faCube as farCube,
  faAngleLeft as farAngleLeft,
  faStar as farStar,
  faArrowRightFromBracket as farArrowRightFromBracket,
  faArrowRotateLeft as farArrowRotateLeft,
  faCamera as farCamera,
  faEthernet as farEthernet,
  faSignal as farSignal,
  faWifi as farWifi,
  faWifiSlash as farWifiSlash,
  faLayerGroup as farLayerGroup,
  faLanguage as farLanguage,
  faKeyboard as farKeyboard,
  faArrowRotateRight as farArrowRotateRight,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faFilter,
  faCaretUp,
  faCaretDown,
  faSearch,
  faSort,
  faSortUp,
  faSortDown,
  faCircle,
  faFileDownload,
  faCheck,
  faInfoCircle,
  faCheckCircle as fasCheckCircle,
  faSpinner as fasSpinner,
  faSpinnerThird as fasSpinnerThird,
  faChartLine,
  faExternalLink,
  faMapMarkerAlt,
  faUserCircle as fasUserCircle,
  faPencil as fasPencil,
  faHeart,
  faAngleDown as fasAngleDown,
  faAngleUp as fasAngleUp,
  faEllipsisVertical,
  faBoxOpen,
  faFileInvoiceDollar,
  faDollarSign,
  faHistory,
  faCreditCardBlank,
  faCreditCard,
  faPartyHorn,
  faAddressBook as fasAddressBook,
  faPeopleSimple as fasPeopleSimple,
  faChartPie as fasChartPie,
  faChartSimple as fasChartSimple,
  faUserCheck as fasUserCheck,
  faEnvelopeCircleCheck as fasEnvelopeCircleCheck,
  faQrcode as fasQrcode,
  faFileSignature as fasFileSignature,
  faLoveseat as fasLoveseat,
  faGear as fasGear,
  faAngleDoubleDown as fasAngleDoubleDown,
  faMagnifyingGlassMinus,
  faFile,
  faArrowUpRightFromSquare,
  faBars,
  faTimes as fasTimes,
  faLocationDot,
  faBagShopping,
  faFaceParty,
  faSquareFull,
  faCircleQuestion,
  faUser as fasUser,
  faUsers as fasUsers,
  faUserGroup as fasUserGroup,
  faFaceViewfinder,
  faFileArrowDown,
  faAngleRight as fasAngleRight,
  faCircleCheck as fasCircleCheck,
  faLockKeyhole as fasLockKeyhole,
  faGrid2Plus as fasGrid2Plus,
  faFilePdf as fasFilePdf,
  faMobileScreenButton as fasMobileScreenButton,
  faCalendarDays as fasCalendarDays,
  faLongArrowLeft as fasLongArrowLeft,
  faCopy as fasCopy,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faBracketsCurly,
  faCars as fasCars,
  faScreenUsers as fasScreenUsers,
  faHotel as fasHotel,
  faPersonHiking as fasPersonHiking,
  faTicketSimple as fasTicketSimple,
  faTicketPerforated as fasTicketPerforated,
  faCube as fasCube,
  faPeopleArrows as fasPeopleArrows,
  faLayerGroup as fasLayerGroup,
  faMedal,
  faChevronRight as fasChevronRight,
  faChevronLeft as fasChevronLeft,
  faArrowLeft as fasArrowLeft,
  faMessage as fasMessage,
  faHandHoldingHeart,
  faCreditCard as fasCreditCard,
  faPuzzlePiece as fasPuzzlePiece,
  faPlug as fasPlug,
  faTicket as fasTicket,
  faFileLines as fasFileLines,
  faClipboardList as fasClipboardList,
  faInfoCircle as fasInfoCircle,
  faStar as fasStar,
  faBolt as fasBolt,
  faPhotoFilm as fasPhotoFilm,
  faArrowPointer as fasArrowPointer,
  faGripDotsVertical as fasGripDotsVertical,
} from '@fortawesome/pro-solid-svg-icons'
import {
  faSquareCheck as fassSquareCheck,
  faXmark as fassXmark,
  faBold as fassBold,
  faItalic as fassItalic,
  faUnderline as fassUnderline,
  faStrikethrough as fassStrikethrough,
  faAlignLeft as fassAlignLeft,
  faAlignCenter as fassAlignCenter,
  faAlignRight as fassAlignRight,
  faAlignJustify as fassAlignJustify,
  faBracketsCurly as fassBracketsCurly,
} from '@fortawesome/sharp-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  farArrowRightFromBracket,
  farArrowRotateLeft,
  farCamera,
  farEthernet,
  farSignal,
  farWifi,
  farWifiSlash,
  fasBolt,
  faFilter,
  faCaretUp,
  faCaretDown,
  faTable,
  faEllipsisV,
  faSync,
  faSearch,
  faCheckSquare,
  faSort,
  faSortUp,
  faSortDown,
  faChartPieAlt,
  faStopwatch,
  faUserFriends,
  faExchange,
  faAngleDown,
  falAngleDown,
  faBell,
  faCalendarAlt,
  faCogs,
  faUserPlus,
  faUpload,
  faDownload,
  faTimes,
  faUser,
  faEdit,
  faUsers,
  faExchangeAlt,
  faEnvelopeOpenText,
  faFolderOpen,
  faBoxArchive,
  faEnvelope,
  faSignIn,
  faAddressBook,
  faTrashAlt,
  faMars,
  faVenus,
  faGenderless,
  faCopy,
  faCircle,
  faFileDownload,
  faPenSquare,
  faLongArrowRight,
  faLongArrowLeft,
  faCog,
  faPlus,
  faCheck,
  faExclamationCircle,
  faExclamationTriangle,
  faMinus,
  faNewspaper,
  faShieldAlt,
  faInfoCircle,
  faBrowser,
  faPlusCircle,
  faEllipsisHAlt,
  faLink,
  faCheckCircle,
  faClone,
  falSearch,
  falEdit,
  falInfoCircle,
  falEye,
  falEyeSlash,
  falMagnifyingGlass,
  falChevronDown,
  faSpinner,
  faSpinnerThird,
  fasCheckCircle,
  faRocketLaunch,
  falCheck,
  faGear,
  faEllipsisH,
  faKeyboard,
  farCheck,
  faFilePdf,
  faMobileAlt,
  faPencil,
  faCode,
  falCheck,
  faFileEdit,
  faFileExport,
  faArrowAltFromBottom,
  faQrcode,
  fasSpinner,
  fasSpinnerThird,
  falCheck,
  faChartLine,
  faList,
  faCalendarPlus,
  faExternalLink,
  faMapMarkerAlt,
  faClock,
  faSortAmountAsc,
  faSortAmountDesc,
  faSortSizeDown,
  falSort,
  falSortUp,
  falSortDown,
  falTable,
  falSync,
  faGlobe,
  falUsers,
  faLock,
  fasUserCircle,
  faBriefcase,
  farEnvelope,
  falUser,
  fasPencil,
  faHeart,
  fasAngleDown,
  faEllipsisVertical,
  faAngleLeft,
  faFileSignature,
  faBoxOpen,
  faFileInvoiceDollar,
  faDollarSign,
  faHistory,
  faCreditCardBlank,
  faCreditCard,
  faBars,
  farMars,
  farVenus,
  farGenderless,
  faPenToSquare,
  faFilterList,
  faLineColumns,
  faTableColumns,
  faDesktop,
  faTablet,
  faMobile,
  faPartyHorn,
  fadBell,
  fadCircleQuestion,
  fadCircleUser,
  fasAddressBook,
  fasPeopleSimple,
  fasChartPie,
  fasChartSimple,
  fasUserCheck,
  farBrowser,
  fasEnvelopeCircleCheck,
  fasQrcode,
  fasFileSignature,
  fasLoveseat,
  fasGear,
  fasAngleDoubleDown,
  faChartPie,
  faCalendarDays,
  faListTimeline,
  faCloudArrowUp,
  faCloudArrowDown,
  faMagnifyingGlassMinus,
  falEllipsisV,
  faExpandArrows,
  faCalendarCheck,
  faCalendarXmark,
  falCalendarPlus,
  faUserPen,
  faPalette,
  faMobileNotch,
  faFileCirclePlus,
  faTrashCan,
  faFile,
  faArrowUpRightFromSquare,
  farPlus,
  fasTimes,
  faLocationDot,
  farExternalLink,
  faUserMinus,
  faDeleteLeft,
  fadLifeRing,
  fadFaceThinking,
  faBagShopping,
  faFaceParty,
  faSquareFull,
  faRocket,
  faMagnifyingGlass,
  faCircleQuestion,
  farPartyHorn,
  faXmark,
  fasUser,
  fasUsers,
  faUserGroup,
  fasUserGroup,
  faFaceViewfinder,
  farArrowsRotate,
  faArrowsRepeat,
  fassXmark,
  fassSquareCheck,
  falAnglesLeft,
  falAnglesRight,
  faFileArrowDown,
  farCalendarDays,
  farMessagesQuestion,
  farPhone,
  falFileInvoice,
  falXmark,
  farEnvelopeOpen,
  falCheckDouble,
  fasAngleRight,
  farBuilding,
  farPlanetRinged,
  farKey,
  falBars,
  farBars,
  fasCircleCheck,
  fasLockKeyhole,
  farAlignJustify,
  farFilterList,
  farArrowUpRightFromSquare,
  faArrowRightToBracket,
  faPersonWalkingArrowRight,
  fasGrid2Plus,
  fasFilePdf,
  farFilePdf,
  fasMobileScreenButton,
  farIdBadge,
  faFileCode,
  fasCalendarDays,
  farLongArrowLeft,
  fasLongArrowLeft,
  farCopy,
  fasCopy,
  fadCars,
  fadScreenUsers,
  fadHotel,
  fadPersonHiking,
  fadTicketPerforated,
  fadPeopleArrows,
  farCar,
  falPiggyBank,
  falList,
  falTrash,
  falTrashCan,
  farTrashCan,
  farLink,
  farUnlink,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faBracketsCurly,
  fassBold,
  fassItalic,
  fassUnderline,
  fassStrikethrough,
  fassAlignLeft,
  fassAlignCenter,
  fassAlignRight,
  fassAlignJustify,
  fassBracketsCurly,
  fasCars,
  fasScreenUsers,
  fasHotel,
  fasPersonHiking,
  fasTicketSimple,
  fasTicketPerforated,
  fasCube,
  fasPeopleArrows,
  faArrowLeft,
  faArrowProgress,
  farArrowsLeftRight,
  fadToggleLargeOn,
  fadToggleLargeOff,
  fasLayerGroup,
  faMedal,
  fasChevronRight,
  fasChevronLeft,
  fasArrowLeft,
  fasAngleUp,
  fasMessage,
  farSidebar,
  farSidebarFlip,
  faHandHoldingHeart,
  farXmark,
  farCalendarXmark,
  farEnvelopeCircleCheck,
  falEnvelopeCircleCheck,
  falPaperPlane,
  falUserClock,
  falUserCheck,
  falTriangleExclamation,
  farPaperPlane,
  farUserClock,
  farUserCheck,
  farTriangleExclamation,
  falSquareXmark,
  falCircleCheck,
  farCircleCheck,
  fasCircleCheck,
  farCartShopping,
  farChevronLeft,
  farChevronDown,
  farArrowDownToBracket,
  farCalendar,
  farMinus,
  fasUserGroup,
  fasCube,
  fasCreditCard,
  fasPuzzlePiece,
  farChevronUp,
  farCircleXmark,
  farTrash,
  fasPlug,
  farClock,
  farClockRotateLeft,
  farTicket,
  fasTicket,
  farLinkSlash,
  fasFileLines,
  fasClipboardList,
  farSparkles,
  farClipboardList,
  farArrowRight,
  farTicketPerforated,
  farBagShopping,
  farGlobe,
  farFileInvoiceDollar,
  farInfoCircle,
  fasInfoCircle,
  farCreditCard,
  farCreditCardBlank,
  farFileLines,
  farLayerGroup,
  farLanguage,
  farKeyboard,
  farArrowRotateRight,
  farScaleBalanced,
  farCog,
  farTicketsSimple,
  farCube,
  farAngleLeft,
  falPrint,
  farStar,
  fasStar,
  falArrowLeft,
  falArrowUp,
  falArrowDown,
  falArrowTurnUp,
  falArrowRotateLeft,
  falArrowRotateRight,
  falDesktop,
  falMobile,
  falLanguage,
  falWifiSlash,
  falFileLines,
  falLayerGroup,
  falPalette,
  falPhotoFilm,
  faHeading,
  faParagraph,
  faImage,
  faHandPointer,
  faCirclePlay,
  faDistributeSpacingVertical,
  faHorizontalRule,
  faShapes,
  faSquareDashed,
  faRectangleWide,
  falAlignLeft,
  falAlignCenter,
  falAlignRight,
  faObjectsAlignTop,
  faObjectsAlignCenterVertical,
  faObjectsAlignBottom,
  faArrowsUpDown,
  faHashtag,
  falPhone,
  falLinkSlash,
  faGripDotsVertical,
  falBold,
  falItalic,
  falUnderline,
  falStrikethrough,
  faListUl,
  faListOl,
  faCrosshairs,
  falHouse,
  falClockRotateLeft,
  fasPhotoFilm,
  falHand,
  falArrowsUpDownLeftRight,
  falDrawCircle,
  falLoveseat,
  falShapes,
  falArrowDownToLine,
  falUpRightAndDownLeftFromCenter,
  falDownLeftAndUpRightToCenter,
  falExpand,
  falCompress,
  falMagnifyingGlassPlus,
  falMagnifyingGlassMinus,
  falRotate,
  falRotateRight,
  falFileImport,
  falSquare,
  falCircle,
  falEllipsis,
  fasArrowPointer,
  fasGripDotsVertical,
  fadDiagramCells,
  falChevronUp,
)

export default FontAwesomeIcon
